export default __webpack_public_path__ + "static/media/satoshi-profile@1x.69a7c839.png";